module.exports = __webpack_public_path__ + "media/images/icon-header-notices-0f063f9fb50ae606c1f0238e8a330601.svg";